import { withStateHandlers } from 'recompose';

export default withStateHandlers({
	modalShowing: false
}, {
	onCloseModal: () => () => ({ modalShowing: false }),
	onShowModal: () => () => ({ modalShowing: true })
});
